import { useState } from "react"
import { useShallow } from "zustand/react/shallow"

// components
import DynamicField from "components/form-fields/DynamicField/DynamicField"
import ArmActions from "../../../components/ArmActions/ArmActions"
import CellValidation from "../../../components/CellValidation/CellValidation"
import CharCounter from "components/CharCounter/CharCounter"

// context
import useAuthoringViewStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringViewStore"
import useProtocolTableArmsStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useProtocolTableArmsStore"

import "./Cell.scss"

const Cell = ({ fieldSchema, fieldKey, onChange, rowIndex, colIndex, tableData, setTableData, cell, tableType }) => {
  const { setArms, setInterventions } = useProtocolTableArmsStore()

  const { readOnly, formView } = useAuthoringViewStore(
    useShallow((state) => ({
      readOnly: state.readOnly,
      formView: state.formView,
    }))
  )

  const [showActions, setShowActions] = useState(false)

  const handleLeft = () => {
    let newData = [...tableData]
    let temp = newData[colIndex - 1]
    newData[colIndex - 1] = newData[colIndex]
    newData[colIndex] = temp
    setTableData([...newData])
  }

  const handleRight = () => {
    let newData = [...tableData]
    let temp = newData[colIndex + 1]
    newData[colIndex + 1] = newData[colIndex]
    newData[colIndex] = temp
    setTableData([...newData])
  }

  const onDeleteArm = () => {
    let newData = [...tableData]
    newData.splice(colIndex, 1)
    setTableData([...newData])

    if (tableType === "arms") {
      setArms([...newData])
    } else if (tableType === "interventions") {
      setInterventions([...newData])
    }
  }

  const renderField = () => {
    let type = fieldSchema.type
    if (type === "string") type = "text"
    let value = cell[fieldKey]
    if (type === "multiselect" && !value) value = []

    return (
      <DynamicField
        type={type}
        fieldProps={{
          value,
          readOnly,
          onChange,
          type: fieldSchema.type,
          options: fieldSchema.enum || [],
        }}
      />
    )
  }

  const getCharCountValue = () => {
    if (typeof cell[fieldKey] === "string") return cell[fieldKey]
    else if (Array.isArray(cell[fieldKey])) return cell[fieldKey].join(", ")
    return ""
  }

  const type = tableType.slice(0, tableType.length - 1)

  const errorKey = `protocol_study_arms_${tableType}_${colIndex}_${fieldKey}`

  return (
    <td
      onMouseEnter={() => setShowActions(true)}
      onMouseLeave={() => setShowActions(false)}
    >
      <div
        className="simple-table-cell"
        id={`root_${errorKey}`}
      >
        {renderField()}
        <div className="simple-table-cell-actions">
          <div className="simple-table-cell-left-actions">
            <CellValidation
              table={tableType}
              errorKey={errorKey}
            />
            {rowIndex === 0 && (
              <CellValidation
                table={tableType}
                errorKey={`protocol_study_arms_${tableType}_${colIndex}`}
              />
            )}
          </div>
          <div className="simple-table-cell-right-actions">
            <ArmActions
              arms={tableData}
              arm={cell}
              colIndex={colIndex}
              showActions={showActions}
              setShowActions={setShowActions}
              showReorderModal={false}
              handleLeft={rowIndex === 0 ? handleLeft : null}
              handleRight={rowIndex === 0 ? handleRight : null}
              canDelete={rowIndex === 0 ? true : false}
              handleDeleteArm={onDeleteArm}
              jpath={`st-${tableType}-${cell.id}-${fieldKey}`}
              type={type}
              label={`${type} ${fieldKey.split("_").join(" ")}`}
            />
            {fieldSchema?.charCountEnabled && formView?.id !== "global" && !readOnly && (
              <CharCounter
                maxChars={fieldSchema?.maxChars}
                value={getCharCountValue()}
              />
            )}
          </div>
        </div>
      </div>
    </td>
  )
}

export default Cell
